module.exports = __webpack_public_path__ + "static/media/golfx.94ce7905.svg";